import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { RouterState } from "mobx-state-router";

import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  none: {
    display: "none"
  }
});

@inject("rootStore")
@observer
class TopNavBase extends Component {
  //===========================================================================

  //===========================================================================

  render() {
    const { authStore } = this.props.rootStore;
    return (
      <div id="header">
        <div className="top-logo">
          <a
            href="#homePanel"
            onClick={() => {
              this.goTo("homePanel");
            }}
          >
            <img
              src="img/top_logo.png"
              alt="logo"
              width="110px"
              height="30px"
            />{" "}
          </a>{" "}
          입문자를 위한 코딩공부
        </div>
        <div className="top-personal">
          {authStore.isLogin() ? authStore.auth.name + "님 접속중 " : ""}
          &nbsp;
          <a
            href="#logout"
            onClick={this.logout}
            className={
              "logout " + (authStore.isLogin() ? "" : this.props.classes.none)
            }
          >
            로그아웃
          </a>{" "}
          &nbsp;
          <a
            href="#loginPanel"
            onClick={() => {
              this.goTo("changePasswordPanel");
            }}
            className={authStore.isLogin() ? "" : this.props.classes.none}
          >
            {" "}
            <i className="fas fa-user" />{" "}
          </a>
          &nbsp;
          <a
            href="#login"
            onClick={() => {
              this.goTo("loginPanel");
            }}
            className={authStore.isLogin() ? this.props.classes.none : ""}
          >
            {" "}
            <i className="fas fa-unlock-alt" />{" "}
          </a>{" "}
        </div>
      </div>
    );
  }
  //===========================================================================
  /**
   * 메뉴 링크 라우트
   */
  goTo = route => {
    const { routerStore } = this.props.rootStore;
    routerStore.goTo(new RouterState(route));
  };
  //===========================================================================
  /**
   * 각 메뉴 기능
   */
  logout = () => {
    const { authStore } = this.props.rootStore;
    authStore.logout();
  };
  //===========================================================================
}

export const TopNav = withStyles(styles)(TopNavBase);
